import { getHomeInfo } from '@/api/home'
  export default {
    state: {
    },
    mutations: {
    },
    getters: {
    },
    actions: {
      getHomeInfo ({ state, commit }) {
        return new Promise((resolve, reject) => {
          try {
            getHomeInfo().then(res => {
              const data = res.data
              resolve(data)
            }).catch(err => {
              reject(err)
            })
          } catch (error) {
            reject(error)
          }
        })
      }
    }
}



// WEBPACK FOOTER //
// ./src/store/module/home.js